var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import * as FluentUIIcons from "@fluentui/react-icons-northstar";
import { Button, Tooltip, tooltipAsLabelBehavior, } from "@fluentui/react-northstar";
import { getText } from "../translations";
var Icons = FluentUIIcons;
export var FocusableIcon = function (_a) {
    var content = _a.tooltip.content, locale = _a.locale, styles = _a.styles, iconProps = __rest(_a, ["tooltip", "locale", "styles"]);
    return (React.createElement(Tooltip, { content: getText(locale, content), accessibility: tooltipAsLabelBehavior, trigger: React.createElement(Button, { text: true, styles: __assign(__assign({}, styles), { padding: "0.0625rem", height: "auto" }) },
            React.createElement(Icon, __assign({}, iconProps))) }));
};
var Icon = function (_a) {
    var icon = _a.icon, styles = _a.styles;
    var componentName = icon + "Icon";
    if (Icons.hasOwnProperty(componentName)) {
        var IconComponent = Icons[componentName];
        return React.createElement(IconComponent, { outline: true, styles: styles });
    }
    else {
        if (process.env.NODE_ENV === "development")
            console.warn("No such icon available: ", icon);
        return null;
    }
};
export default Icon;
//# sourceMappingURL=Icon.js.map